export default class CodecService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('owner/customExports', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('owner/customExports/' + id, params)
	}

	runExport(id, params){
		return this.apiService.callGet('owner/customExports/runExport/' + id, params);
	}
}



// WEBPACK FOOTER //
// ./src/service/CustomExportService.js